import { render, staticRenderFns } from "./Data404.vue?vue&type=template&id=0aed723e&scoped=true&"
import script from "./Data404.vue?vue&type=script&lang=js&"
export * from "./Data404.vue?vue&type=script&lang=js&"
import style0 from "./Data404.vue?vue&type=style&index=0&id=0aed723e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed723e",
  null
  
)

export default component.exports